import React, { useEffect, useState } from 'react'
import searchIcon from '../../assets/images/searchIcon.svg'
import patientImg from '../../assets/images/dashboardPatientImg.svg'
import arrow from '../../assets/images/selectArrow.svg'
import SelectField from '../../components/inputFeild/SelectField';
import TextField from '../../components/inputFeild/TextFeild';
import { Avatar } from '@mui/material';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import calender from '../../assets/images/calendar.svg'
import facilityIcon from '../../assets/images/facilityIcon.svg'
// import { MSG_INDIVIDUAL, MSG_NURSING_STAFF, MSG_PROVIDER } from '../../config/permissions';
import dayjs from 'dayjs';
import { useAppDispatch, useAppSelector } from '../../helpers/hook';
import { loginPageSlices } from '../loginPage/loginPageSlice';
import ReactQuill from 'react-quill';
import { hasHighPriority, itemsPerPage } from '../../config/constants';
import { approveTriageQueueMessage, fetchTriageProfilePic, fetchTriageQueueList, fetchTriageUserList } from '../../services/triageQueueServices';
import { CommonSlices } from '../common/commonSlice';
import { ITriageQueueState, ITriageUserState, ReceiverUser } from '../../models/triageQueueInterface';
import ButtonType from '../../components/button/ButtonType';
import Paginations from '../../components/Pagination';
import { TriageQueueDataSliceSlices } from './triageQueueSlice';
import { IFetchProfilePic } from '../../models/dashboardInterfaces';
import MessageTo from '../../components/messageTo/MessageTo';

let searchTimeout: NodeJS.Timeout;

const TriageQueue = () => {
  const dispatch = useAppDispatch();
  const { token, unid, client, logedUsername, loginUserRole, logedUserID } = useAppSelector(loginPageSlices);
  const { navFacility } = useAppSelector(CommonSlices);
  const { triageQueueListData, allUserList, paginationTotalCount, avatarUrls, loading } = useAppSelector(TriageQueueDataSliceSlices);


  const [otherSettings, setOtherSettings] = useState({
    isDateFocused: false,
    isDateFilterApplied: false,
    selectedMessageID: 0,
  });

  const [filterSection, setFilterSection] = useState<ITriageQueueState>({
    search: '',
    date_from: '',
    date_to: '',
    status: false,
    page: 1
  });

  const [userList, setUserList] = useState<ReceiverUser[]>([]);



  useEffect(() => {
    if (loading === 'success') {
      fetchTriageQueueListData();
    }
  }, [loading]);

  useEffect(() => {
    setUserList(allUserList);
  }, [allUserList]);

  useEffect(() => {
    fetchTriageQueueListData();
  }, [navFacility]);

  useEffect(() => {
    if (triageQueueListData.length > 0) {
      handleProfilePic(Array.from(new Set(triageQueueListData.map(item => Number(item.id)))));
    }
  }, [triageQueueListData]);

  const fetchTriageQueueListData = (override: Partial<ITriageQueueState> = {}) => {
    const payload = {
      token,
      unid,
      client,
      user: logedUsername,
      group: loginUserRole,
      facility: navFacility,
      ...filterSection,
      ...override,
    };

    dispatch(fetchTriageQueueList(payload));
  };

  const handleChange = (name: string, value: any) => {
    setFilterSection((prev) => ({ ...prev, [name]: value }));
  };


  const handleDateFilter = (name: string) => {
    if (name === "close") {
      setFilterSection(prev => ({ ...prev, date_from: '', date_to: '', status: false }));
      fetchTriageQueueListData({ date_from: '', date_to: '', status: false });
      setOtherSettings((prev) => ({ ...prev, isDateFocused: false, isDateFilterApplied: false }));
    } else {
      fetchTriageQueueListData();
      setOtherSettings((prev) => ({ ...prev, isDateFocused: false, isDateFilterApplied: true }));
    }
    setOtherSettings((prev) => ({ ...prev, selectedMessageID: 0 }));
  }

  const handleProfilePic = (sender_id: number[]) => {
    //To fetch profile pic of corresponding sender
    const req: IFetchProfilePic = {
      unid, token,
      sender: sender_id,
      // sender: Array.from(new Set(messageInboxData.map(item => Number(item.sender_id)))),
    };
    dispatch(fetchTriageProfilePic(req));
  }

  // pagination    
  const handlePageChange = (pageNumber: number) => {
    handleChange('page', pageNumber)
    fetchTriageQueueListData({ page: pageNumber });
  };

  const handleFetchTriageUserList = (value: string, triageId: number) => {

    setOtherSettings((prev) => ({ ...prev, selectedMessageID: triageId }));

    const req: ITriageUserState = {
      unid,
      token,
      client,
      facility: [Number(value)],
      user_id: logedUserID,
      general_patient: false,
    };

    dispatch(fetchTriageUserList({ triage_id: triageId, form: req }));
  };

  const handleApproveMessage = (id: number, data: ReceiverUser[]) => {

    
    if(data.every(item => item.isSelected === false)) {
      return;
    }

    type MessageTo = {
      [key: string]: number[];
    };

    const selected = data.filter(item => item.isSelected);

    const message_to: MessageTo = {};

    selected.forEach(item => {
      if (item.group_name === "") {
        const groupKey = item.value;
        const userIds = selected
          .filter(u => u.group_name === groupKey && u.isGroup)
          .map(u => u.user_id)
          .filter((id): id is number => typeof id === "number");

        message_to[groupKey] = userIds;
      } else if (!item.isGroup) {
        if (!message_to.INDIVIDUAL) message_to.INDIVIDUAL = [];
        if (typeof item.user_id === "number") {
          message_to.INDIVIDUAL.push(item.user_id);
        }
      }
    });

    const req: ITriageQueueState = {
      unid,
      token,
      id,
      message_to,
    };

    dispatch(approveTriageQueueMessage(req));
  };

  return (

    <div className='w-full bg-[var(--color-F5F5F5)] h-full'>
      <div className='flex justify-start items-center  pt-4 pb-8 pl-12 pr-8'>
        <div>
          <h1 className='text-2xl text-[var(--color-212121)] '>Triage Queue</h1>
        </div>
      </div>
      <div className='flex gap-4  items-center   pb-9 pl-12 pr-8'>


        <div className='flex items-center gap-[9px] bg-[var(--color-white)] border border-[var(--color-BDBDBD)] rounded px-3 py-[9px]'>
          <img src={searchIcon} alt='search' loading='lazy' decoding='async' />
          <input
            type='search'
            name='search'
            value={filterSection.search}
            onChange={(e) => {

              const val = e.target.value;
              setFilterSection(prev => ({ ...prev, search: val }));

              clearTimeout(searchTimeout);
              searchTimeout = setTimeout(() => {
                fetchTriageQueueListData({ search: val });
              }, 1000); // debounce delay
            }}
            className='focus:outline-none border-none text-xs w-52'
            placeholder='Search Patient'
          />
        </div>

        <div className='flex items-center gap-3'>
          <div className='common-dropdown '>
            <div className={` ${(otherSettings.isDateFocused || otherSettings.isDateFilterApplied) && "h-[440px] min-w-[440px] "} extra-space   w-36 h-12 `} onClick={() => otherSettings.isDateFilterApplied && handleDateFilter("close")}></div>

            <div className="text-base font-medium tracking-[0.05px] text-[var(--color-212121)] flex items-center flex-wrap gap-1">
              {otherSettings.isDateFilterApplied ? <div className="text-[var(--color-0048D4)]" onClick={() => handleDateFilter("close")}>
                Reset Filter
                {/* <CloseRoundedIcon
                  onClick={() => handleDateFilter("close")}
                  fontSize="small"
                  className="text-[var(--color-danger)] ml-1"
                /> */}
              </div> : "Filter"}
            </div>


            <div className='dropdown-list min-w-[440px]   z-[2]'>
              <div className="custom-scrollBar max-h-[276px]">
                <div className='mb-4 pr-5'>
                  <SelectField
                    className=' select-message  py-[9px]  border-[var(--color-BDBDBD)] w-[180px]'
                    name='status'
                    label='Status'
                    value={!filterSection.status ? "1" : "2"}
                    onChange={e => handleChange(e.target.name, e.target.value === "1" ? false : true)}
                    options={[
                      { name: 'Under review', id: "1" },
                      { name: 'Processed', id: "2" },
                    ]}
                  />
                </div>
                <hr className='mb-4 mr-5' />
                <div className='flex gap-3 items-center pr-5'>
                  <TextField
                    name='date_from'
                    label='From date'
                    max={new Date().toISOString().split("T")[0]}
                    value={filterSection.date_from}
                    onChange={e => handleChange(e.target.name, e.target.value)}
                    placeholder='From date'
                    onFocus={(e: any) => {
                      e.target.setAttribute("type", "date");
                      setOtherSettings((prev) => ({ ...prev, isDateFocused: true }));
                      setTimeout(() => {
                        setOtherSettings((prev) => ({ ...prev, isDateFocused: false }));
                      }, 9000);
                    }}
                    onBlur={(e: any) => {
                      if (!e.target.value) {
                        e.target.setAttribute("type", "text");
                      }
                      setOtherSettings((prev) => ({ ...prev, isDateFocused: false }));
                    }}
                    className='h-[42px]'
                  />
                  <div className='mt-6'>-</div>

                  <TextField
                    name='date_to'
                    label='To date'
                    className='h-[42px]'
                    min={filterSection.date_from || undefined}
                    max={new Date().toISOString().split("T")[0]}
                    value={filterSection.date_to}
                    onChange={e => handleChange(e.target.name, e.target.value)}
                    placeholder='To date'
                    onFocus={(e: any) => {
                      e.target.setAttribute("type", "date");
                      setOtherSettings((prev) => ({ ...prev, isDateFocused: true }));
                    }}
                    onBlur={(e: any) => {
                      if (!e.target.value) {
                        e.target.setAttribute("type", "text");
                        setOtherSettings((prev) => ({ ...prev, isDateFocused: false }));
                        setTimeout(() => {
                          setOtherSettings((prev) => ({ ...prev, isDateFocused: false }));
                        }, 9000);
                      }
                    }}
                  />
                </div>

                <hr className='mt-4 mr-5' />

                <div className='flex justify-end pr-6 pt-6 gap-6'>

                  {otherSettings.isDateFilterApplied &&
                    <ButtonType
                      type='webCardbtn'
                      buttonLabel='Reset Filter'
                      buttonType='submit'
                      onClick={() => handleDateFilter("close")}
                      className='px-12 bg-[var(--color-0048D4)]'
                    />}

                  <ButtonType
                    type='webCardbtn'
                    buttonLabel='Apply'
                    buttonType='submit'
                    onClick={() => handleDateFilter("")}
                    className='px-12 bg-[var(--color-0048D4)]'
                  />
                </div>
              </div>
            </div>
            {!otherSettings.isDateFilterApplied && <>&nbsp;&nbsp;</>}&nbsp;
            <img src={arrow} alt="arrow" loading='lazy' decoding='async' height={24} width={24} />
          </div>

        </div>




      </div>
      <div className='pl-12 pr-8 '>


        {triageQueueListData.length > 0 ? <div className='w-full pb-8'>



          <div className='flex flex-col gap-3'>

            {triageQueueListData.map(item => <>
              <div className='pt-3 pb-6 px-6 bg-[var(--color-white)]' key={item.id}>
                <div className="flex items-center justify-between border-b pb-3">
                  <div className="flex gap-3 items-center">
                    <Avatar className='h-9 w-9' alt={item.sender_name} src={avatarUrls[item.id] || ''} sx={{ border: `3px solid white` }} />
                    <span className='text-sm font-medium text-[var(--color-424242)]'>{item.sender_name}</span>
                  </div>
                  <div className="flex gap-6 items-center">
                    <div className='flex flex-col gap-1 items-start w-fit text-[11px] font-medium text-[var(--color-212121)]'>
                      <span className=' flex items-center gap-1'>
                        <img src={calender} alt="calender" loading='lazy' decoding='async' className='h-5 w-auto ' />
                        {dayjs(item.created_on).format('MMM D, YYYY, hh:mm A')} {dayjs().diff(item.created_on, 'day') !== 0 && ` (${dayjs().diff(item.created_on, 'day')} days ago)`}
                      </span>
                      <span className=' flex items-center gap-1'>
                        <img src={facilityIcon} alt="facilityIcon" /> {item.facility_name}
                      </span>
                    </div>

                  </div>
                </div>
                <div className={`w-full flex  border-b gap-3 ${otherSettings.selectedMessageID === item.id ? "items-start justify-center" : "items-center"}`}>

                  <div className={`flex w-full gap-3   py-3 flex-wrap ${otherSettings.selectedMessageID === item.id ? "items-start justify-center" : "items-center"}`}>
                    <p className='text-[13px] font-medium text-[var(--color-424242)]'>To</p>

                    {!item.approval_status ? <>
                      {otherSettings.selectedMessageID === item.id ?
                        <div className='flex-1'><MessageTo value={userList} onChange={(value) => setUserList(value)} /> </div> :
                        item.receiver?.map(item => <span className='active-to' key={item.value}>{item.name}</span>)}
                    </> : <>
                      {item.patient_receiver?.map(item => <span className='active-to my-1' >{item}</span>)}
                    </>}
                  </div>


                  {!item.approval_status && <ButtonType
                    type='webCardbtn'
                    buttonLabel={otherSettings.selectedMessageID === item.id ? 'Reset Destination' : 'Change Destination'}
                    buttonType='button'
                    onClick={() => otherSettings.selectedMessageID === item.id ? setOtherSettings((prev) => ({ ...prev, selectedMessageID: 0 })) : handleFetchTriageUserList(item.facility_id, item.id)}
                    className='h-10 my-3 text-center leading-[0] !important text-[14px] rounded-3xl bg-[var(--color-0048D4)]'
                  />}

                </div>
                {item.approval_status &&
                  <div className='w-full flex  border-b justify-between py-3'>
                    <div className='flex gap-3 items-center'>
                      <p className='text-[13px] font-medium text-[var(--color-424242)]'>Approved Destination</p>
                      {item.receiver?.map(item => <span className='active-to' key={item.value}>{item.name}</span>)}
                    </div>

                    <div className='flex flex-col gap-1 items-start w-fit text-[11px] font-medium text-[var(--color-212121)]'>
                      <span className=' flex items-center gap-1'>
                        <PersonOutlineRoundedIcon fontSize='small' color='action' /> {item.approved_by}
                      </span>
                      <span className=' flex items-center gap-1'>
                        <img src={calender} alt="calender" loading='lazy' decoding='async' className='h-5 w-auto ' />
                        {dayjs(item.approved_on).format('MMM D, YYYY, hh:mm A')} {dayjs().diff(item.approved_on, 'day') !== 0 && ` (${dayjs().diff(item.approved_on, 'day')} days ago)`}
                      </span>
                    </div>

                  </div>
                }

                {(item.related_patient && item.related_patient?.length > 0) && <p className='text-xs my-3 text-[var(--color-212121)]'>Patient: {item.related_patient}</p>}


                <div className={'flex justify-between ' + `${(item.related_patient && item.related_patient?.length > 0) ? "" : " pt-3 "}`}>


                  {item.priority === hasHighPriority && <span className='text-[var(--color-danger)] mt-[9px]'>!</span>}
                  <ReactQuill theme="snow" value={item.content.replace(/(\r\n|\r|\n)/g, '<br> ')} modules={{ toolbar: false }} className={`w-full h-full border-none `} readOnly={true} />


                  {/* <Button sx={{ height: "28px" }} variant="contained" size='small'  >
                    Send
                  </Button> */}
                  {!item.approval_status &&
                    <ButtonType
                      type='webCardbtn'
                      buttonLabel='Approve'
                      buttonType='submit'
                      onClick={() => handleApproveMessage(item.id, otherSettings.selectedMessageID === item.id ? userList : item.receiver)}
                      className='h-10 text-center leading-[0] !important text-[14px] rounded-3xl bg-[var(--color-0048D4)]'
                    />
                  }
                </div>
              </div>
            </>)}


          </div>


        </div> :
          <div className='w-full h-full  flex flex-col gap-6 items-center  justify-center mt-16'>
            <img src={patientImg} alt="" loading='lazy' decoding='async' />
            <h2 className='text-2xl font-medium text-[var(--color-424242)] tracking-[0.05px]'>No messages</h2>
          </div>
        }
      </div>

      <Paginations
        totalItems={paginationTotalCount}
        itemsPerPage={itemsPerPage}
        currentPage={filterSection.page ?? 1}
        setCurrentPage={handlePageChange}
      />


      {/* <ConfirmationMessage
      title={message.CFPCareConnect}
      description={message.confirmUserApprove}
      open={showApproveConfirmation}
      textType={false}
      type={'warning'}
      buttonTwoOnClick={() => setShowApproveConfirmation(false)}
      buttonOneOnClick={() => handleConfiramationApprove()}
      buttonLabelOne={'Approve'}
      buttonLabelTwo='Cancel'
    /> */}
    </div>
  )
}

export default TriageQueue